import { generateClient } from "aws-amplify/api";
import { batchAddOptions } from "../graphql/mutations";
import { Option } from "db/definitions";
import { recordSentry } from "utils/recordSentry";

/**
 * Calls the batch resolver and sens all image docs up for creation
 * @author Eric Webb <ewebb@factorearth.com>
 * @param options The option documents we want ot create
 * @returns Any erorrs that come up
 */
async function batchCreateOptions(options: Option[]): Promise<boolean> {
	if (options.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddOptions,
				variables: { options: options },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateOptions;
